function PopoverContent() {
  return null;
}

PopoverContent.displayName = 'PopoverContent';

export default PopoverContent;



// WEBPACK FOOTER //
// ./elements/Popover/PopoverContent.js